import axios from 'axios';
import configData from '../config.json';
const API_URL = `${configData.SERVER_URL}/api`;

class AuthService {
  login(email, password) {
    return axios
      .post(API_URL + '/login', {
        email,
        password,
      })
      .then((response) => {
        console.log('AuthService login response:', response);
        console.log('Response data:', response.data);
        console.log('User data to be stored:', response.data.data);

        if (response.data.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data.data));
        }

        return response.data;
      })
      .catch((err) => {
        console.log('Login error:', err);
      });
  }
  forgot_pass(email) {
    return axios
      .post(API_URL + '/forgot_pass', {
        email,
      })
      .then((response) => {
        if (response.data.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data.data));
        }

        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  async register(username, email, password, fname, lname, role_id, mobile_no) {
    const registered_data = await axios.post(API_URL + '/register', {
      username,
      email,
      password,
      fname,
      lname,
      role_id,
      mobile_no,
    });

    if (
      registered_data.data.data !== undefined &&
      registered_data.data.data.accessToken
    ) {
      const accessToken = registered_data.data.data.accessToken;
      const config = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };

      const userData = registered_data.data.data;
      let url =
        API_URL + `/role/${role_id}/user/${registered_data.data.data.id}`;

      const roledata = await axios.post(url, {}, config);

      const newData = {
        ...userData,
        ...roledata.data.data,
      };
      localStorage.setItem('user', JSON.stringify(newData));
      return { data: newData, success: true };
    } else {
      return registered_data;
    }
    // return roledata;
  }

  updateCurrentUser(key, value) {
    let user = JSON.parse(localStorage.getItem('user'));
    if (!user) return null;

    // Support nested keys e.g. "configurations.card_no"
    const keys = key.split('.');
    let obj = user;
    for (let i = 0; i < keys.length - 1; i++) {
      if (!obj[keys[i]]) obj[keys[i]] = {}; // create nested object if missing
      obj = obj[keys[i]];
    }
    obj[keys[keys.length - 1]] = value;

    // Save back to localStorage
    localStorage.setItem('user', JSON.stringify(user));

    return user;
  }
  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  async registerAgency(agencyData) {
    const formData = new FormData();

    // Append all agency data to formData
    formData.append('fname', agencyData.fname);
    formData.append('lname', agencyData.lname);
    formData.append('email', agencyData.email);
    formData.append('password', agencyData.password);
    formData.append('password_confirmation', agencyData.password_confirmation);
    formData.append('phone', agencyData.phone);
    formData.append('agency_name', agencyData.agency_name);
    formData.append('business_license', agencyData.business_license);
    formData.append('contact_person', agencyData.contact_person);
    formData.append('contact_phone', agencyData.contact_phone);
    formData.append('contact_email', agencyData.contact_email);
    formData.append('address', agencyData.address);
    formData.append('city', agencyData.city);
    formData.append('state', agencyData.state);
    formData.append('country', agencyData.country);
    formData.append('postal_code', agencyData.postal_code);

    // Append documents if provided
    if (agencyData.registration_certificate) {
      formData.append(
        'registration_certificate',
        agencyData.registration_certificate,
      );
    }
    if (agencyData.business_license_file) {
      formData.append(
        'business_license_file',
        agencyData.business_license_file,
      );
    }
    if (agencyData.other_documents) {
      formData.append('other_documents', agencyData.other_documents);
    }

    const registered_data = await axios.post(
      API_URL + '/agency/register',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (
      registered_data.data.data !== undefined &&
      registered_data.data.data.accessToken
    ) {
      const accessToken = registered_data.data.data.accessToken;
      const config = {
        headers: { Authorization: `Bearer ${accessToken}` },
      };

      const userData = registered_data.data.data;

      // Set agency role (assuming role_id 3 for agencies)
      let url = API_URL + `/role/3/user/${registered_data.data.data.id}`;

      const roledata = await axios.post(url, {}, config);

      const newData = {
        ...userData,
        ...roledata.data.data,
      };
      localStorage.setItem('user', JSON.stringify(newData));
      return { data: newData };
    } else {
      return registered_data;
    }
  }

  async updateUserProfile(userId, profileData) {
    const accessToken = this.getCurrentUser()?.accessToken;
    if (!accessToken) {
      throw new Error('No access token found');
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    };

    const response = await axios.put(
      `${configData.SERVER_URL}/api/user/${userId}/profile`,
      profileData,
      config,
    );
    console.log('api response', response);
    if (response.data.data) {
      // Update localStorage with new user data
      const currentUser = this.getCurrentUser();
      const updatedUser = { ...currentUser, ...response.data.data };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    }

    return response;
  }
}
export default new AuthService();
